import { render, staticRenderFns } from "./SendMobileCode.vue?vue&type=template&id=7cfef296&scoped=true"
import script from "./SendMobileCode.vue?vue&type=script&lang=js"
export * from "./SendMobileCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfef296",
  null
  
)

export default component.exports